"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableBody = exports.TableHeader = exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _docFlux = require("@harvest-profit/doc-flux");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Renders text.
 */
var TableRowContainer = /*#__PURE__*/function (_DOMComponent) {
  _inherits(TableRowContainer, _DOMComponent);

  var _super = _createSuper(TableRowContainer);

  function TableRowContainer() {
    _classCallCheck(this, TableRowContainer);

    return _super.apply(this, arguments);
  }

  _createClass(TableRowContainer, [{
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }], [{
    key: "transform",
    value: function transform(DOM) {
      var variables = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cells = [];
      var widths = {};

      for (var i = 0; i < DOM.value.length; i += 1) {
        var child = DOM.value[i];

        if (child.ref) {
          cells.push(child.ref.constructor.transform(child, variables));
          if (child.props.width) widths[i] = child.props.width;
        }
      }

      return {
        rows: cells,
        height: DOM.props.height || 'auto',
        widths: widths
      };
    }
  }]);

  return TableRowContainer;
}(_docFlux.DOMComponent);

exports["default"] = TableRowContainer;

_defineProperty(TableRowContainer, "propTypes", {
  children: _propTypes["default"].arrayOf(_propTypes["default"].any).isRequired
});

var TableHeader = /*#__PURE__*/function (_TableRowContainer) {
  _inherits(TableHeader, _TableRowContainer);

  var _super2 = _createSuper(TableHeader);

  function TableHeader() {
    _classCallCheck(this, TableHeader);

    return _super2.apply(this, arguments);
  }

  _createClass(TableHeader, null, [{
    key: "transform",
    value: function transform(DOM) {
      var variables = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var cells = [];
      var widths = {};
      var colCount = 0;

      for (var i = 0; i < DOM.value.length; i += 1) {
        var child = DOM.value[i];

        if (child.ref) {
          cells.push(child.ref.constructor.transform(child, variables));
          if (child.props.width) widths[i] = child.props.width;

          if (child.props.colSpan) {
            for (var col = 1; col < child.props.colSpan; col += 1) {
              cells.push('');
            }
          }
        }

        if (cells.length > colCount) {
          colCount = cells.length;
        }
      }

      return {
        rows: cells,
        height: DOM.props.height,
        widths: widths,
        colCount: colCount
      };
    }
  }]);

  return TableHeader;
}(TableRowContainer);

exports.TableHeader = TableHeader;

var TableBody = /*#__PURE__*/function (_TableRowContainer2) {
  _inherits(TableBody, _TableRowContainer2);

  var _super3 = _createSuper(TableBody);

  function TableBody() {
    _classCallCheck(this, TableBody);

    return _super3.apply(this, arguments);
  }

  _createClass(TableBody, null, [{
    key: "transform",
    value: function transform(DOM) {
      var variables = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rows = [];
      var heights = [];
      var widths = {};
      var colCount = 0;

      for (var i = 0; i < DOM.value.length; i += 1) {
        var child = DOM.value[i];

        if (child.ref) {
          var row = child.ref.constructor.transform(child, variables);
          rows.push(row.rows);
          heights.push(row.height || 'auto');
          widths = _objectSpread(_objectSpread({}, widths), row.widths);

          if (row.rows.length > colCount) {
            colCount = row.rows.length;
          }
        }
      }

      return {
        rows: rows,
        heights: heights,
        widths: widths,
        colCount: colCount
      };
    }
  }]);

  return TableBody;
}(TableRowContainer);

exports.TableBody = TableBody;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@harvest-profit/doc-flux-pdfs/dist/DOMComponents/TableRowContainer.js
// module id = 14
// module chunks = 0